import { render } from "./massChangePopup.vue?vue&type=template&id=0fa50cfc&scoped=true"
import script from "./massChangePopup.vue?vue&type=script&lang=js"
export * from "./massChangePopup.vue?vue&type=script&lang=js"

const cssModules = {}
import style0 from "./mass.less?vue&type=style&index=0&id=0fa50cfc&scoped=true&lang=less&module=true&external"
cssModules["$style"] = style0

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__cssModules',cssModules],['__scopeId',"data-v-0fa50cfc"]])

export default __exports__